// extracted by mini-css-extract-plugin
export default {"app":"Tab3_app__jl9UP","areaItem":"Tab3_areaItem__n0cWJ","selected":"Tab3_selected__yLMF6"};